import { Component, OnInit, Input } from '@angular/core';
import { BoxListTruckService } from '../box-list-truck/box-list-truck.service';
import { GraphicService } from '../shared/graphic.service';
import { DiaRoteiro, Util } from '../shared/Util';
import { JsonReturn } from '../shared/interface/generic-interface';
import { DualInfoComponentComponent } from '../shared/componentes/dual-info-component/dual-info-component.component';
import { NgIf, NgFor, DecimalPipe, DatePipe } from '@angular/common';

@Component({
    selector: 'box-info-journey',
    templateUrl: './box-info-journey.component.html',
    styleUrls: ['./box-info-journey.component.css'],
    standalone: true,
    imports: [DualInfoComponentComponent, NgIf, NgFor, DecimalPipe, DatePipe]
})
export class BoxInfoJourneyComponent implements OnInit 
{
  @Input() dados;
  tempoTotal: string = '-';
  diasRoteiro: DiaRoteiro[] = [];
  tempoTotalRoteiro: string = '00:00'
  tempoTotalVisita: string = '00:00'



  constructor
  (
    private boxListTruckService: BoxListTruckService,
    public graphicService: GraphicService
  ) 
  { }

  async ngOnInit() 
  {
    await this.getTempoTotalRtoeiro()
    this.ordenarDiasRoteiro()
  }



  async getTempoTotalRtoeiro(){
    
      let response: JsonReturn = await this.boxListTruckService.getTempoTotalRtoeiro(this.dados.IdRoteiro)
      this.diasRoteiro = response.response;
      let minutos = 0;
      let minutosParados = 0;
      this.diasRoteiro.forEach((dia: any) => {
        minutos += Util.converterMinutos(dia.HoraCalcAcumuladaT);
        minutosParados += Util.converterMinutos(dia.HoraCalcAcumuladaP);
      })
      this.tempoTotalRoteiro = Util.converteStringHora(minutos) + ':00';
      this.tempoTotalVisita = Util.converteStringHora(minutosParados) + ':00';

  }

  ordenarDiasRoteiro() {
    this.diasRoteiro.sort((diaA, diaB) => {
      const timestampDiaA = new Date(diaA.DT).getTime();
      const timestampDiaB = new Date(diaB.DT).getTime();
      return timestampDiaA - timestampDiaB;
    });
  }


  msToTime(duration: number)
  {
      let milliseconds = parseInt(((duration % 1000) / 100).toFixed(0));
      let seconds = parseInt(((duration / 1000) % 60).toFixed(0));
      let minutes = parseInt(((duration / (1000 * 60)) % 60).toFixed(0));
      let hours = parseInt(((duration / (1000 * 60 * 60)) % 24).toFixed(0));

      let hoursAux = (hours < 10) ? "0" + hours.toString() : hours.toString();
      let minutesAux = (minutes < 10) ? "0" + minutes.toString() : minutes.toString();
      let secondsAux = (seconds < 10) ? "0" + seconds.toString() : seconds.toString();

      return hoursAux + ":" + minutesAux + ":" + secondsAux
  }
}